/**
 * Those are setting for jQuery Validation
 * for improve compatibility with Bootstrap 3
 * when using most common HTML markup.
 */


// Dependecies
//
var $ = require('jquery');


// Function to retreive the boostrap state class
// base on the text color class.
//
function getStateClass(errorClass) {

    if (errorClass.match(/text-danger/gi)) {
        return "has-error";
    }

    else if (errorClass.match(/text-warning/gi)) {
        return "has-warning";
    }

    else if (errorClass.match(/text-success/gi)) {
        return "has-success";
    }

    return false;
};


// Export the options object
//
module.exports = {

    // Error tag
    //
    // This is not the most semantic tag, but it wont cause
    // problem with any parent tag.
    //
    errorElement: 'span',

    // Error style
    // 
    // Set of bootstrap class to style error message.
    //
    errorClass: 'help-block text-400 text-danger',


    // Valid style
    //
    // Set of bootstrap class to style valid message.
    //
    validClass: 'help-block text-400 text-success',


    // Error placement
    //
    errorPlacement: function (error, element) {
        var $input = element,
            $error = error;

        // Checkbox
        if ($input.is('[type="checkbox"]')) {
            var $parent = $input.parent('label');
            if ($parent.length > 0) {
                $parent.after($error);
            }
        }
        // Radio
        else if ($input.is('[type="radio"]')) {
            var $parent = $input.parent('label').parent('.radio').parent('.form-group');
            if ($parent.length > 0) {
                $parent.append($error);
            }
        }
        // Default
        else {
            $input.after($error);
        }
    },


    // Field highlight
    //
    // Logic for DOM manipulation on hightlight (error, valid, etc.)
    //
    highlight: function (element, errorClass) {
        var $input = $(element),
            stateClass = getStateClass(errorClass);
        
        // If we were able to define a state class
        if (stateClass) {
            // Checkbox
            if ($input.is('[type="checkbox"]')) {
                var $parent = $input.parent('label').parent('.checkbox');
                if ($parent.length > 0) {
                    $parent.addClass(stateClass);
                }
            }
            // Radio
            else if ($input.is('[type="radio"]')) {
                var $parent = $input.parent('label').parent('.radio').parent('.form-group');
                if ($parent.length > 0) {
                    $parent.addClass(stateClass);
                }
            }
            // Regular input, textarea, or select
            else {
                var $parent = $input.parent('.form-group');
                if ($parent.length > 0) {
                    $parent.addClass(stateClass);
                }
            }
        }
    },


    // Field uremove highlight
    //
    // Logic for DOM manipulation on remove hightlight (error, valid, etc.)
    //
    unhighlight: function (element, errorClass) {
        var $input = $(element),
            stateClass = getStateClass(errorClass);

        // If we were able to define a state class
        if (stateClass) {
            // Checkbox
            if ($input.is('[type="checkbox"]')) {
                var $parent = $input.parent('label').parent('.checkbox');
                if ($parent.length > 0) {
                    $parent.removeClass(stateClass);
                }
            }
            // Radio
            if ($input.is('[type="radio"]')) {
                var $parent = $input.parent('label').parent('.radio').parent('.form-group');
                if ($parent.length > 0) {
                    $parent.removeClass(stateClass);
                }
            }
                // Regular input, textarea, or select
            else {
                var $parent = $input.parent('.form-group');
                if ($parent.length > 0) {
                    $parent.removeClass(stateClass);
                }
            }
        }
    }
};


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/forms-validation/options/defaults.js
 ** module id = 82
 ** module chunks = 0 1
 **/